import { useState } from 'react'
import { Accordion } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
import type { KbFaq } from '../types'

interface FAQSectionProps {
    faqs: KbFaq[]
}

const FAQSection = ({ faqs }: FAQSectionProps) => {
    const allCategories = Array.from(
        new Set(faqs.map((f) => f.category_label))
    )
    const [activeFilter, setActiveFilter] = useState<string>('All')

    const filtered =
        activeFilter === 'All'
            ? faqs
            : faqs.filter((f) => f.category_label === activeFilter)

    return (
        <section className="kb-faq">
            <div className="kb-faq__header">
                <div className="kb-faq__icon">
                    <FontAwesomeIcon icon={faCircleQuestion} />
                </div>
                <h2 className="kb-faq__title">Frequently Asked Questions</h2>
                <p className="kb-faq__subtitle">
                    Quick answers to common questions
                </p>
            </div>

            <div className="kb-faq__filters">
                <button
                    className={`kb-faq__filter ${activeFilter === 'All' ? 'kb-faq__filter--active' : ''}`}
                    onClick={() => setActiveFilter('All')}
                >
                    All
                </button>
                {allCategories.map((cat) => (
                    <button
                        key={cat}
                        className={`kb-faq__filter ${activeFilter === cat ? 'kb-faq__filter--active' : ''}`}
                        onClick={() => setActiveFilter(cat)}
                    >
                        {cat}
                    </button>
                ))}
            </div>

            <Accordion className="kb-faq__accordion">
                {filtered.map((faq, idx) => (
                    <Accordion.Item
                        key={faq.id}
                        eventKey={String(idx)}
                        className="kb-faq__item"
                    >
                        <Accordion.Header className="kb-faq__question">
                            {faq.question}
                        </Accordion.Header>
                        <Accordion.Body className="kb-faq__answer">
                            <p>{faq.answer}</p>
                            <span className="kb-faq__category-badge">
                                {faq.category_label}
                            </span>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </section>
    )
}

export default FAQSection
